import baseStyled, { css as baseCss, ThemedCssFunction, ThemedStyledInterface } from 'styled-components';

import { TopBarThemedTheme } from './themes/types';

const styled = baseStyled as ThemedStyledInterface<TopBarThemedTheme>;
const css = baseCss as ThemedCssFunction<TopBarThemedTheme>;

export const TopBarThemed = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0.5vh;

  .home-icon {
    font-size: 1.9vw;
    color: white;
    border: 1px solid #267DAC;
    padding: 0.5vh;
    height: fit-content;
    width: fit-content;
    border-radius: 0.5vh;
    ${({ theme }) => css`
      background-color: ${theme.mode.topBarThemed.headingBGColor};
    `}
  }

  .heading {
    font-size: 2vh;
    font-weight: bold;
    border-bottom: 1px solid black;
    margin-left: auto;
    margin-right: auto;
    padding: 0.5vh 1vh;
    border-radius: 0.5vh;
    ${({ theme }) => css`
      color: ${theme.mode.topBarThemed.headingColor};
      background-color: ${theme.mode.topBarThemed.headingBGColor};
    `}
  }

  .spacer {
    margin-right: ${({ showHome }) => (showHome ? '5vw' : '0')};
  }
`;
